import React, { Component } from 'react';
import { Phone, Mail, ChevronRight } from 'lucide-react';
interface ButtonProps {
  href: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: 'phone' | 'mail' | 'arrow' | 'none';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  href,
  variant = 'primary',
  size = 'md',
  icon = 'none',
  children,
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-colors duration-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-legal-red';
  const variants = {
    primary: 'bg-legal-red text-white hover:bg-legal-redHover shadow-sm',
    secondary: 'bg-legal-dark text-white hover:bg-black shadow-sm',
    outline: 'border-2 border-legal-dark text-legal-dark hover:bg-legal-dark hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const IconComponent = {
    phone: Phone,
    mail: Mail,
    arrow: ChevronRight,
    none: null
  }[icon];
  return <a href={href} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-12">
      {IconComponent && <IconComponent className={`w-5 h-5 ${children ? 'mr-2' : ''}`} data-id="element-13" />}
      {children}
    </a>;
}